import { render, staticRenderFns } from "./WorkComments.vue?vue&type=template&id=25a6e896&scoped=true"
import script from "./WorkComments.vue?vue&type=script&lang=js"
export * from "./WorkComments.vue?vue&type=script&lang=js"
import style0 from "./WorkComments.vue?vue&type=style&index=0&id=25a6e896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a6e896",
  null
  
)

export default component.exports